module.exports = __webpack_public_path__ + "static/media/JobApplication.dc134378.jpg";